module.exports = __webpack_public_path__ + "img/鎏金面膜+珍银面膜_03.c9b04443.jpg";